import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './fr.json';

/**
 * Application monolingue française. i18next reste en place pour que tous les
 * libellés transitent par `t()` : ajouter une langue plus tard n'exigera pas
 * de réécrire les composants.
 */
void i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr } },
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
